import QuoteFormFieldHelp from "../../../../components/QuoteFormFieldHelp";
import React from "react";
import {
  helpImageFinderDayConsumption,
  helpTextFinder,
  helpTitleFinder,
  helpImageFinderInvoiceType
} from "../../../../helpers/forms/corporate/quoteForm/helpFields";

export default fields => {
  const invoiceTypeElement = fields.invoiceType;
  const knowledgeOfConsumptionElement = fields.knowledgeOfConsumption;
  const dayConsumptionElement = fields.dayConsumption;
  const nightConsumptionElement = fields.nightConsumption;
  const levelOfConsumptionElement = fields.levelOfConsumption;
  const postalCodeElement = fields.postalCode;
  const standingOrderElement = fields.standingOrder;
  const corporateNameElement = fields.corporateName;
  const customerFirstNameElement = fields.customerFirstName;
  const customerLastNameElement = fields.customerLastName;
  const customerMobilePhoneNumberElement = fields.customerMobilePhoneNumber;
  const termsAndPoliciesAgreementElement = fields.termsAndPoliciesAgreement;
  const capacityChargeElement = fields.capacityCharge;

  return {
    invoiceType: {
      "ui:widget": "FormCustomSelect",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={invoiceTypeElement.helpTitle}
          helpText={invoiceTypeElement.helpText}
          helpExampleImageUrl={helpImageFinderInvoiceType(formData,invoiceTypeElement)}
        />
      ),
      classNames: "invoiceType"
    },
    knowledgeOfConsumption: {
      "ui:widget": "FormCustomSelect",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={knowledgeOfConsumptionElement.helpTitle}
          helpText={knowledgeOfConsumptionElement.helpText}
          helpExampleImageUrl={
            knowledgeOfConsumptionElement.helpExampleImageUrl
          }
        />
      ),
      classNames: "knowledgeOfConsumption"
    },
    knowledgeOfConsumptionForLead: {
      "ui:widget": "FormCustomSelect",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={knowledgeOfConsumptionElement.helpTitle}
          helpText={knowledgeOfConsumptionElement.helpTextForLead}
          helpExampleImageUrl={
            knowledgeOfConsumptionElement.helpExampleImageUrl
          }
        />
      ),
      classNames: "knowledgeOfConsumptionForLead"
    },
    capacityCharge: {
      "ui:widget": "FormCustomNumberInput",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={capacityChargeElement.helpTitle}
          helpText={
            formData.knowledgeOfConsumption === true
              ? capacityChargeElement.helpTextKnownConsumption
              : capacityChargeElement.helpText
          }
          helpExampleImageUrl={capacityChargeElement.helpExampleImageUrl}
        />
      ),
      classNames: "capacityCharge"
    },
    levelOfConsumption: {
      "ui:widget": "FormCustomSelect",
      "ui:placeholder": "Επιλέξτε",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={levelOfConsumptionElement.helpTitle}
          helpText={levelOfConsumptionElement.helpText}
          helpExampleImageUrl={levelOfConsumptionElement.helpExampleImageUrl}
        />
      ),
      classNames: "levelOfConsumption"
    },
    dayConsumption: {
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={helpTitleFinder(formData,dayConsumptionElement)}
          helpText={helpTextFinder(formData,dayConsumptionElement)}
          helpExampleImageUrl={helpImageFinderDayConsumption(formData,dayConsumptionElement)}
        />
      ),
      classNames: "dayConsumption"
    },
    nightConsumption: {
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={nightConsumptionElement.helpTitle}
          helpText={
            formData.knowledgeOfConsumption === true
              ? nightConsumptionElement.helpTextKnownConsumptionNight
              : nightConsumptionElement.helpText
          }
          helpExampleImageUrl={nightConsumptionElement.helpExampleImageUrlNight}
        />
      ),
      classNames: "nightConsumption"
    },
    postalCode: {
      "ui:widget": "FormCustomSelect",
      "ui:placeholder": "Επιλέξτε",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={postalCodeElement.helpTitle}
          helpText={postalCodeElement.helpText}
          helpExampleImageUrl={postalCodeElement.helpExampleImageUrl}
        />
      ),
      classNames: "postalCode"
    },
    standingOrder: {
      "ui:widget": "FormCustomRadio",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={standingOrderElement.helpTitle}
          helpText={standingOrderElement.helpText}
          helpExampleImageUrl={standingOrderElement.helpExampleImageUrl}
        />
      ),
      classNames: "standingOrder"
    },
    corporateName: {
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={corporateNameElement.helpTitle}
          helpText={corporateNameElement.helpText}
          helpExampleImageUrl={corporateNameElement.helpExampleImageUrl}
        />
      ),
      classNames: "corporateName"
    },
    customerFirstName: {
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={customerFirstNameElement.helpTitle}
          helpText={customerFirstNameElement.helpText}
          helpExampleImageUrl={customerFirstNameElement.helpExampleImageUrl}
        />
      ),
      classNames: "customerFirstName"
    },
    customerLastName: {
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={customerLastNameElement.helpTitle}
          helpText={customerLastNameElement.helpText}
          helpExampleImageUrl={customerLastNameElement.helpExampleImageUrl}
        />
      ),
      classNames: "customerLastName"
    },
    customerMobilePhoneNumber: {
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={customerMobilePhoneNumberElement.helpTitle}
          helpText={customerMobilePhoneNumberElement.helpText}
          helpExampleImageUrl={
            customerMobilePhoneNumberElement.helpExampleImageUrl
          }
        />
      ),
      classNames: "customerMobilePhoneNumber"
    },
    currentSupplier: {
      "ui:widget": "FormCustomSelect",
      "ui:placeholder": "Επιλέξτε"
    },
    currentProduct: {
      "ui:widget": "FormCustomSelect",
      "ui:placeholder": "Επιλέξτε"
    },
    termsAndPoliciesAgreement: {
      "ui:widget": "FormCheckBox",
      "ui:customHelp": formData => (
        <QuoteFormFieldHelp
          helpTitle={termsAndPoliciesAgreementElement.helpTitle}
          helpText={termsAndPoliciesAgreementElement.helpText}
        />
      ),
      classNames: "termsAndPoliciesAgreement hidden-title"
    },
    "ui:order": [
      "invoiceType",
      "knowledgeOfConsumption",
      "knowledgeOfConsumptionForLead",
      "capacityCharge",
      "levelOfConsumption",
      "dayConsumption",
      "nightConsumption",
      "postalCode",
      "standingOrder",
      "currentSupplier",
      "currentProduct",
      "corporateName",
      "customerFirstName",
      "customerLastName",
      "customerMobilePhoneNumber",
      "termsAndPoliciesAgreement"
    ]
  };
};
